import { ReactNode } from "react";
import "./downloads.css"
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function Qgc(): ReactNode {
    const { t } = useTranslation(['qgc', 'base']);

    return (
        <div className='max-width text-page-padding'>
            <div className='mission-download'>
                <div className='mp-logo'>
                    <img src="/image/QGC.png" alt="" />
                </div>
                <div>
                    <div className='heading'>{t('header')}</div>
                    <div className='text'>
                        <p>{t('string_1')}</p>
                        <p>{t('string_2')} <a href='http://qgroundcontrol.com/'>{t('href_text')}</a></p>
                    </div>
                </div>
                <div className='download-buttons'>
                    <div>{t('Download', { ns: "base" })}:</div>
                    <Button
                        variant='success'
                        href='https://disk.yandex.ru/d/JhFZsU2wXkdi1w'
                        target='_blank'
                    >
                        Windows
                    </Button>
                    <Button
                        variant='success'
                        href='https://disk.yandex.ru/d/luEjCNXiR2Zb6w'
                        target='_blank'
                    >
                        Ubuntu
                    </Button>
                    <Button
                        variant='success'
                        href='https://disk.yandex.ru/d/ZULkofNEfF9czg'
                        target='_blank'
                    >
                        Android
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Qgc;